import { useQuery } from '@tanstack/react-query';
import { AIGuideApi } from './api';

const QUERY_KEYS = {
  all: ['ai-guide'] as const,
  entries: () => [...QUERY_KEYS.all, 'entries'] as const,
  entry: (entryId: string) => [...QUERY_KEYS.all, 'entry', entryId] as const,
};

// The guide is embedded in the server binary, so it only changes on deploy
const GUIDE_STALE_TIME = 60 * 60 * 1000;

/** Every guide entry, without bodies */
export const useGuideEntries = () => {
  return useQuery({
    queryKey: QUERY_KEYS.entries(),
    queryFn: () => AIGuideApi.listEntries(),
    staleTime: GUIDE_STALE_TIME,
  });
};

/** One entry with its Markdown body */
export const useGuideEntry = (entryId: string | null) => {
  return useQuery({
    queryKey: QUERY_KEYS.entry(entryId ?? ''),
    queryFn: () => AIGuideApi.getEntry(entryId ?? ''),
    enabled: !!entryId,
    staleTime: GUIDE_STALE_TIME,
  });
};
